// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound_root__1oUuI","header":"NotFound_header__1fD1j","subHeader":"NotFound_subHeader__2ifvd"};